<template>
  <v-card class="popup-address-card">
    <v-card-text
      class="pa-0 fill-height"
      ref="content"
      @click.capture="onContentClick"
    >
      <category-block
        :target="category"
        :position="position"
        :container="false"
      />
      <!-- :position="config.templateBlock.codInt" -->
    </v-card-text>
  </v-card>
</template>

<style lang="scss">
.popup-address-card.v-card {
  border-radius: 14px !important;
  overflow: hidden;

  .v-card__text {
    overflow-y: auto;
  }
}

/*
* Il CSS desktop arriva dal BO.
*
* Qui gestiamo solamente il responsive perché il renderer
* del CSS_STYLE del CMS non sembra applicare correttamente
* le media query.
*/
@media (max-width: 768px) {
  .popup-address-card {
    /*
     * Layout:
     *
     * [ IMMAGINE ]
     * [ CONTENUTO ]
     */
    .locker-card-wrap .locker-card {
      flex-direction: column !important;
      flex-wrap: nowrap !important;
    }

    /*
     * IMMAGINE
     *
     * Non impostiamo un'altezza fissa:
     * deve mantenere le proporzioni originali.
     */
    .locker-card-wrap .locker-card__image {
      flex: 0 0 auto !important;

      width: calc(100% - 40px) !important;
      height: auto !important;

      min-width: 0 !important;
      min-height: 0 !important;

      /*
       * Sovrascrive i margini desktop definiti sul BO.
       */
      margin: 20px 20px 0 !important;

      border-radius: 18px !important;
      overflow: hidden !important;

      align-self: auto !important;
    }

    .locker-card-wrap .locker-card__image img {
      display: block !important;

      width: 100% !important;
      height: auto !important;
      min-height: 0 !important;

      /*
       * L'immagine viene mostrata interamente.
       * Nessun crop.
       */
      object-fit: contain !important;
      object-position: center !important;

      border-radius: inherit !important;
    }

    /*
     * CONTENUTO
     */
    .locker-card-wrap .locker-card__content {
      flex: 0 0 auto !important;

      width: 100% !important;
      min-width: 0 !important;

      padding: 24px 28px 28px !important;

      justify-content: flex-start !important;
      gap: 16px !important;
    }

    /*
     * TITOLO
     */
    .locker-card-wrap .locker-card__title {
      font-size: 1.4rem !important;
      line-height: 1.2 !important;
    }

    /*
     * FEATURES
     */
    .locker-card-wrap .locker-card__features {
      gap: 14px !important;
    }

    .locker-card-wrap .locker-card__feature {
      gap: 12px !important;
    }

    .locker-card-wrap .locker-card__check {
      flex: 0 0 34px !important;

      width: 34px !important;
      height: 34px !important;

      font-size: 18px !important;
    }

    .locker-card-wrap .locker-card__feature-title {
      margin-bottom: 2px !important;
      font-size: 0.95rem !important;
    }

    .locker-card-wrap .locker-card__feature-text {
      font-size: 0.86rem !important;
      line-height: 1.35 !important;
    }

    /*
     * CTA
     */
    .locker-card-wrap .locker-card__cta {
      padding: 14px 20px !important;
      font-size: 0.95rem !important;
    }

    .locker-card-wrap .locker-card__secondary {
      font-size: 0.85rem !important;
    }
  }
}

/*
* Smartphone piccoli
*/
@media (max-width: 420px) {
  .popup-address-card {
    .locker-card-wrap .locker-card {
      border-radius: 18px !important;
    }

    /*
     * IMPORTANTE:
     * niente height: 100px e niente flex-basis fisso,
     * altrimenti torniamo a tagliare l'immagine.
     */
    .locker-card-wrap .locker-card__image {
      flex: 0 0 auto !important;

      width: calc(100% - 32px) !important;
      height: auto !important;

      margin: 16px 16px 0 !important;
    }

    .locker-card-wrap .locker-card__image img {
      width: 100% !important;
      height: auto !important;

      object-fit: contain !important;
    }

    .locker-card-wrap .locker-card__content {
      padding: 20px 20px 24px !important;
      gap: 14px !important;
    }

    .locker-card-wrap .locker-card__title {
      font-size: 1.3rem !important;
    }

    .locker-card-wrap .locker-card__features {
      gap: 12px !important;
    }

    .locker-card-wrap .locker-card__feature-text {
      font-size: 0.84rem !important;
    }

    .locker-card-wrap .locker-card__cta {
      padding: 13px 18px !important;
    }
  }
}
</style>

<script>
import AnalyticsService from "~/service/analyticsService";

export default {
  name: "PopupAddress",

  props: {
    category: {
      type: Object,
      required: true
    },
    address: {
      type: Object,
      default: () => ({})
    },
    position: {
      type: String,
      default: "position1"
    }
  },

  mounted() {
    AnalyticsService.trackEvent(
      "view_popup_locker",
      "store",
      this.address?.addressName
    );
  },

  methods: {
    // The CMS content only provides plain <a> links without classes/ids,
    // so we distinguish the two CTAs by their order in the rendered markup:
    // the 1st link starts the locker flow,
    // the 2nd one keeps the store pickup flow.
    //
    // Listening in the capture phase and stopping propagation prevents the
    // generic StaticText/clickHandler mixin (bound closer to the target) from
    // also handling the same click and opening the link in a new tab/window.
    onContentClick(e) {
      let anchor = e.target.closest && e.target.closest("a");

      if (!anchor || !this.$refs.content) {
        return;
      }

      let anchors = Array.from(this.$refs.content.querySelectorAll("a"));
      let index = anchors.indexOf(anchor);

      if (index === -1) {
        return;
      }

      e.preventDefault();
      e.stopPropagation();

      //  AnalyticsService.trackEvent(
      //   "locker_preference",
      //   ["switched_to_locker", "closed_dialog"],
      //   [index === 0, false]
      // );

      if (index === 0) {
        this.$emit("submit", "locker");
        AnalyticsService.trackEvent(
          "click_cta_locker",
          "store",
          this.address?.addressName
        );
      } else if (index === 1) {
        this.$emit("submit", "store");
      }
    }
  }
};
</script>
